"use strict";function e(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var r=e(require("styled-components")).default.li`
    .accordion-item {
        border: none;
        padding: 0 ${({theme:e})=>e.spacing.large};
        margin: 0 -${({theme:e})=>e.spacing.large};

        > button {
            border-bottom: solid 1px ${({theme:e})=>e.colors.grey[400]};

            svg {
                path {
                    fill: ${({theme:e})=>e.colors.primary.dark};
                }
            }
        }

        .wrapper {
            overflow: visible;

            > .content {
                padding: 25px 0;
            }
        }
    }
`;module.exports=r;
//# sourceMappingURL=styles.js.map
